export const availableLanguages = [
  { label: "English", value: "en" },
  { label: "French", value: "fr" },
];
